<template>
    <div>
        <!-- ヘッダー -->
        <div class="mb-4">
            <h2 class="fw-bold text-success mb-1">
                <i class="fa-solid fa-arrow-right-arrow-left"></i>
                相手科目マスタ
            </h2>
        </div>
        <div class="container" v-cloak>
            <div class="mb-3 text-end">
                <button class="btn btn-outline-secondary" @click="editAccount()">
                    <span class="fa-solid fa-plus"></span>
                    新規作成
                </button>
            </div>
            <div v-for="v in accounts" :key="v.id" class="card mb-2">
                <div class="card-body d-flex justify-content-between align-items-center">
                    <div class="d-flex justify-content-start">
                        <div class="me-4">
                            <button class="btn btn-outline-secondary me-2" @click="editAccount(v.id)">
                                <span class="fa-solid fa-pencil"></span>
                            </button>
                        </div>
                        <div class="me-4">
                            <div class="me-4 d-flex align-items-baseline">
                                <span class="fs-5 fw-bold">
                                    <ruby>
                                        {{ v.name }}
                                        <rt>
                                            {{ v.furigana }}
                                        </rt>
                                    </ruby>
                                </span>
                            </div>
                            <span class="me-4">
                                <span class="badge bg-secondary" data-bs-toggle="tooltip" title="会計システム連携用の科目コード">
                                    科目コード
                                </span>
                                <span class="ms-1">{{ v.code }}</span>
                            </span>
                        </div>
                    </div>
                    <div>
                        <button class="btn btn-danger ms-2" @click="destroy(v)">
                            <span class="fa-solid fa-xmark"></span>
                            抹消
                        </button>
                    </div>
                </div>
            </div>
    
            <!-- 編集モーダル -->
            <partner-accounts-editor
                :partner_account_id="partner_account_id"
                @close="closeModal"
                @saved="reload()"
            />
        </div>
    </div>
</template>

<script>
import PartnerAccountsEditor from './partnerAccountsEditor.vue'
export default {
    components: { PartnerAccountsEditor },
    data() {
        return {
            accounts: [],
            modals: [],
            partner_account_id: null,
        }
    },
    methods: {
        reload() {
            axios.get('/api/master/partner-accounts').then(res => {
                this.accounts = res.data;
            }).catch(err => {Alert.err(err)});;
        },
        editAccount(id = null) {
            this.partner_account_id = id;
            setTimeout(() => {
                this.modals['partner-account-editor'].show();
            });
        },
        closeModal(id) {
            this.modals[id]?.hide();
        },
        destroy(account) {
            swal({
                title: "相手科目抹消",
                text: "この相手科目を抹消します。\nもとに戻せません。\nよろしいですか？",
                icon: "error",
                buttons: ["キャンセル", "抹消"],
                dangerMode: true,
            }).then(confirm => {
                if (confirm) {
                    axios.delete(`/api/master/partner-accounts/${account.id}`).then(() => {
                        Alert.msg("抹消しました");
                        this.reload();
                    }).catch((err) => {
                        Alert.err(err);
                    });
                }
            });
        }
    },
    mounted() {
        this.modals['partner-account-editor'] = new bootstrap.Modal(document.getElementById('partner-account-editor'));
        this.reload()
    }
}
</script>
